(function () {
    var apiScriptIsLoaded = false;
    var loadingPromise = null; // Fulfilled when the API finishes loading
    var loadingPromiseWithWait = null; // Fulfilled when the document is loaded, the wait period has elapsed, AND the API finishes loading

    var checkAlreadyLoaded = () => {
        if (window.YT && apiScriptIsLoaded !== true) {
            console.debug("YouTubeApiLoader.js: Already Loaded. Script loaded outside of this class.");
            apiScriptIsLoaded = true;
        }
        if (apiScriptIsLoaded === true) {
            console.debug("YouTubeApiLoader.js: Already Loaded.");
        }
        return apiScriptIsLoaded;
    };

    window.YouTubeApiLoader = {
        /** Loads the YouTube API returning a promise that is fullfilled upon completion
         *  @param {bool} waitForPageLoad - Whether or not to wait for page load.  This is ignored if the page has already loaded.
         *  @returns {Promise} - A promise that is fulfilled when the API has completed loading and is ready.
         */
        Load(waitForPageLoad = true) {
            if (checkAlreadyLoaded()) {
                return Promise.resolve(true);
            }

            if (loadingPromise !== null) {
                return loadingPromise;
            }

            // If the page isn't already loaded, delay load in order to help page speed.
            if (waitForPageLoad && document.readyState !== 'complete') {
                if (loadingPromiseWithWait === null) {
                    console.debug("YouTubeApiLoader.js: Loading YouTube API with wait.");
                    loadingPromiseWithWait = new Promise(resolve => {
                        // Delay the load - This prevents it from hurting page speed scores
                        $(document).ready(() => setTimeout(() => {
                            window.YouTubeApiLoader.Load(false).then(() => resolve(true));
                        }, 2000));
                    });
                }
                return loadingPromiseWithWait;
            }

            loadingPromise = new Promise((accept, reject) => {
                console.debug("YouTubeApiLoader.js: Loading YouTube API");
                var existingFunc = window.onYouTubeIframeAPIReady;
                if (existingFunc) {
                    console.debug("YouTubeApiLoader.js: onYouTubeIframeAPIReady already Exists. Saving to another variable.", existingFunc);
                }

                if (existingFunc && !Object.getOwnPropertyDescriptor(window, "onYouTubeIframeAPIReady").set) {
                    existingFunc = null; // Prevent a callback loop when onYouTubeIfraeAPIReady is defined to be a getter/setter
                }
                var onApiReady = function () {
                    apiScriptIsLoaded = true;
                    if ((typeof existingFunc === "function")) {
                        existingFunc();
                    }
                    accept(true);
                };
                window.onYouTubeIframeAPIReady = onApiReady;
                $.getScript("https://www.youtube.com/iframe_api")
                    .done((_script, _textStatus) => {
                        console.debug("YouTubeApiLoader.js: Script Loaded");
                        setTimeout(() => {
                            if (apiScriptIsLoaded === false && window.onYouTubeIframeAPIReady !== onApiReady) {
                                console.debug("onYouTubeIframeAPIReady function was overwritten.");
                                if (checkAlreadyLoaded()) {
                                    accept(true);
                                }
                            }
                        }, 1000);
                    })
                    .fail((jqxhr, settings, exception) => {
                        console.error(exception);
                        reject(exception);
                    });
            });
            return loadingPromise;
        }
    };
}());